import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import { CloseIcon } from "@components/Icons";

import { formatReadDate } from "../table/table.helpers";
import {
  INotificationWithUsers,
  IUserNotification,
} from "@modules/notifications/model/INotifications";

interface Props {
  notification: INotificationWithUsers;
  onClose: () => void;
}

const ReadConfirmationModal: React.FC<Props> = ({ notification, onClose }) => {
  const [reads, setReads] = useState<IUserNotification[]>([]);

  useEffect(() => {
    setReads(
      (notification.notificationUsers || []).filter((user) => user.readAt)
    );
  }, [notification]);

  return (
    <Dialog
      open
      onClose={() => onClose()}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: "#333333" }}>
          Confirmação de leitura <strong> #{`${notification.id}`}</strong>
        </Typography>

        <IconButton
          aria-label="fechar"
          onClick={() => onClose()}
          size="small"
          sx={{ color: "#4F4F4F" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          mt: 1,
          pt: 2,
          pb: 3,
          px: 3,
        }}
      >
        {reads?.length === 0 ? (
          <Typography sx={{ fontSize: 14, color: "#4F4F4F" }}>
            Nenhuma leitura registrada ainda.
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {reads.map((read, index) => (
              <Box
                key={`${read.userEmail}-${index}`}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: 14,
                }}
              >
                <Typography sx={{ color: "#4F4F4F" }}>
                  {read.userName} - {read.userEmail}
                </Typography>

                <Typography
                  sx={{
                    color: "#00A650",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  {read.readAt ? formatReadDate(read.readAt) : "Não lida"}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReadConfirmationModal;
